module.exports = __webpack_public_path__ + "img/skip-backward-btn.f3382653.svg";